import { SxProps, Theme } from "@mui/material";

export const requestNotificationStyles = {
  snackbar: {
    top: { xs: 16, md: 24 },
  } as SxProps<Theme>,
  alert: {
    width: "100%",
    minWidth: { xs: "280px", md: "420px" },
    boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.15)",
    borderRadius: 2,
    alignItems: "flex-start",
  } as SxProps<Theme>,
  title: {
    fontWeight: 700,
    lineHeight: 1.2,
  } as SxProps<Theme>,
};
